import { Component, type ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Button, EmptyState } from '@svetoch/ui';
import { WorkspaceProvider } from './WorkspaceContext';
import { Shell } from './Shell';
import { CatalogPage } from '../features/catalog/CatalogPage';
import { UIKitPage } from '../features/ui-kit/UIKitPage';
import { RecordPage } from '../features/record/RecordPage';

class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  render() {
    if (this.state.hasError) return <div className="fatal-error"><EmptyState title="Не удалось открыть рабочее пространство" description="Обновите страницу, чтобы попробовать ещё раз." action={<Button onClick={() => window.location.reload()}>Обновить страницу</Button>} /></div>;
    return this.props.children;
  }
}

export function App() {
  return <ErrorBoundary><a className="skip-link" href="#main-content">К содержимому</a><WorkspaceProvider><Shell><Routes>
    <Route path="/" element={<Navigate to="/catalog/bibliographic" replace />} />
    <Route path="/catalog/bibliographic" element={<CatalogPage />} />
    <Route path="/catalog/bibliographic/:recordId" element={<RecordPage />} />
    <Route path="/ui-kit" element={<UIKitPage />} />
    <Route path="*" element={<div className="page-content"><EmptyState title="Страница не найдена" description="Проверьте адрес или вернитесь в каталог." action={<a className="text-link" href="/catalog/bibliographic">Вернуться в каталог</a>} /></div>} />
  </Routes></Shell></WorkspaceProvider></ErrorBoundary>;
}
